import { fork } from 'redux-saga/effects';
import currentUserWatchers from './currentUserSaga';
import fieldWatchers from './fieldSaga';
import pastWeatherWatchers from './pastWeatherSaga';
import weatherForecastWatchers from './weatherForecastSaga';
import analyticsSagaWatchers from './analyticsSaga';

export default function* root() {
  yield fork(currentUserWatchers);
  yield fork(fieldWatchers);
  yield fork(pastWeatherWatchers);
  yield fork(weatherForecastWatchers);
  yield fork(analyticsSagaWatchers);
}
